import React from "react";

/**
 * Global Context
 *
 * Used to store global state that needs to be accessed across the application.
 * It can be used to store user information, application settings, or any other
 * data that needs to be shared across components.
 */
export const GlobalContext = React.createContext(null);

/**
 * Document Generation Context
 *
 * This context is specifically used for managing the state related to document generation.
 * It can store information such as the current document being generated, the status of the generation process,
 * and any errors that may occur during document generation.
 */
export const DocumentGenerationContext = React.createContext(null);
